export enum ImageType {
  SPLASH_SCREEN = "SPLASH_SCREEN",
  PACK_IMAGE = "PACK_IMAGE",
  BANNER = "BANNER",
  NOTIFICATION = "NOTIFICATION",
  STORE_BANNER = "STORE_BANNER",
  CHALLENGE_REWARD_IMAGE = "CHALLENGE_REWARD_IMAGE",
  MILESTONE_REWARD_IMAGE = "MILESTONE_REWARD_IMAGE",
  TEAM_BADGE = "TEAM_BADGE",
  OPERATOR_LOGO_DESKTOP_STACKED = "OPERATOR_LOGO_DESKTOP_STACKED",
  OPERATOR_LOGO_FTUE_INITIAL = "OPERATOR_LOGO_FTUE_INITIAL",
  OPERATOR_LOGO_IN_GAME_TOP = "OPERATOR_LOGO_IN_GAME_TOP",
}

export interface ImageDimensions {
  width: number;
  height: number;
  label: string;
  description: string;
}

export const DEFAULT_IMAGE_DIMENSIONS: Record<ImageType, ImageDimensions> = {
  [ImageType.SPLASH_SCREEN]: {
    width: 386,
    height: 616,
    label: "Splash Screen",
    description: "Portrait orientation",
  },
  [ImageType.PACK_IMAGE]: {
    width: 250,
    height: 400,
    label: "Pack Image",
    description: "Portrait orientation",
  },
  [ImageType.BANNER]: {
    width: 720,
    height: 203,
    label: "Banner",
    description: "Landscape orientation",
  },
  [ImageType.NOTIFICATION]: {
    width: 125,
    height: 200,
    label: "Notification",
    description: "Portrait orientation",
  },
  [ImageType.STORE_BANNER]: {
    width: 720,
    height: 202,
    label: "Store Banner",
    description: "Landscape orientation",
  },
  [ImageType.CHALLENGE_REWARD_IMAGE]: {
    width: 250,
    height: 400,
    label: "Challenge Reward Image",
    description: "Portrait orientation",
  },
  [ImageType.MILESTONE_REWARD_IMAGE]: {
    width: 170,
    height: 270,
    label: "Milestone Reward Image",
    description: "Portrait orientation",
  },
  [ImageType.OPERATOR_LOGO_DESKTOP_STACKED]: {
    width: 494,
    height: 468,
    label: "Operator Logo",
    description: "PNG fits within a 494 x 468 box (aspect ratio preserved); SVG is kept as-is",
  },
  [ImageType.OPERATOR_LOGO_FTUE_INITIAL]: {
    width: 750,
    height: 220,
    label: "Operator Logo",
    description: "PNG fits within a 750 x 220 box (aspect ratio preserved); SVG is kept as-is",
  },
  [ImageType.OPERATOR_LOGO_IN_GAME_TOP]: {
    width: 358,
    height: 101,
    label: "Operator Logo",
    description: "PNG fits within a 358 x 101 box (aspect ratio preserved); SVG is kept as-is",
  },
  [ImageType.TEAM_BADGE]: {
    width: 650,
    height: 500,
    label: "Team Badge",
    description: "Resized to WebP within a 650 x 500 box; aspect ratio preserved, not cropped",
  },
};

export function calculateAspectRatioDimensions(
  originalWidth: number,
  originalHeight: number,
  newValue: number,
  changedDimension: "width" | "height",
): { width: number; height: number } {
  const aspectRatio = originalWidth / originalHeight;

  if (changedDimension === "width") {
    return {
      width: newValue,
      height: Math.round(newValue / aspectRatio),
    };
  } else {
    return {
      width: Math.round(newValue * aspectRatio),
      height: newValue,
    };
  }
}
